/* eslint-disable no-else-return */
/* eslint-disable max-lines */
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

export const INITIAL_STATE = {
  'loading': false,
  'customerData': [],
};

export const customerTracking = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_CUSTOMER_TRACKING]: (state) => ({
      ...state,
      'loading': true,
      'customerData': [],
    }),
    [ActionTypes.FETCHED_CUSTOMER_TRACKING]: (state, action) => ({
      ...state,
      'loading': false,
      'customerData': action.response.data,
    }),
    [ActionTypes.FETCHED_CUSTOMER_TRACKING_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'customerData': [],
    }),
    [ActionTypes.CLEAN_CUSTOMER_TRACKING_STATE]: (state) => ({
      ...state,
      'loading': false,
      'customerData': [],
    }),
  })(state, action);
};
